// Helpers compartilhados pelos sub-componentes de Admin.
// Extraído de Admin.tsx durante refactor topológico.

import { fetchAuthSession } from 'aws-amplify/auth';

export async function getToken(): Promise<string> {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString() ?? '';
}

export const fmtDate = (s: string | Date | null) => {
  if (!s) return '—';
  const d = typeof s === 'string' ? new Date(s) : s;
  return d.toLocaleDateString('pt-BR');
};

export const fmtDateTime = (s: string | Date | null) => {
  if (!s) return '—';
  const d = typeof s === 'string' ? new Date(s) : s;
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
};
